import {useMessages} from "i18n";
import Seo from "../seo/Seo";
import {FeaturesContent} from "../home/landing/FeaturesContent";
import {useFaqItems} from "../home/landing/faq";
import {faqPageLd} from "../seo/structuredData";

/**
 * Public, pre-rendered /features page (ui#97). The crawlable twin of the topbar "Features" dialog —
 * both render from the same {@link ../home/landing/howItWorks.ts} data. Targets the winnable
 * "p2p file transfer in browser / no upload" cluster the dialog copy could never rank for (portal).
 *
 * The FAQ section + its FAQPage JSON-LD moved here from the home page in ui#110: Google requires
 * FAQPage structured data to match FAQ content visible on the SAME URL, and the FAQ is now rendered
 * by {@link FeaturesContent}. The JSON-LD is fed the SAME `useFaqItems()` array the section renders,
 * so the markup can never drift from the on-page questions. Locale-aware: the FAQ copy follows the
 * active catalog (en on /features, ro on /ro/features), matching how the pre-rendered trees are built.
 */
export function Component() {
	const {seo} = useMessages();
	const faqItems = useFaqItems();
	return (
		<>
			<Seo
				title={seo.features.title}
				description={seo.features.description}
				path="/features"
				jsonLd={faqPageLd(faqItems)}
			/>
			<FeaturesContent/>
		</>
	);
}
